import DeleteIcon from "@atlaskit/icon/core/delete";
import DownloadIcon from "@atlaskit/icon/core/download";
import ChevronRightIcon from "@atlaskit/icon/core/chevron-right";
import {token} from "@atlaskit/tokens";
import {AnankeText} from "@vesta/ananke/components/anankeText";

type ModuleMoreActionsDrawerContentProps = {
    /** Omit on archived slice or when export is unavailable. */
    onExport?: () => void;
    onArchivedData?: () => void;
};

/**
 * Mobile BottomDrawer: Export (opens export options drawer) and Archived Data.
 */
export function ModuleMoreActionsDrawerContent({
    onExport,
    onArchivedData,
}: ModuleMoreActionsDrawerContentProps) {
    const optionRowStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        gap: token("space.150", "12px"),
        height: "40px",
        minHeight: "32px",
        padding: `0 ${token("space.150", "12px")}`,
        borderRadius: "4px",
        background: token("color.background.input"),
        color: token("color.text"),
        cursor: "pointer",
    };

    const OptionRowButton = ({
        label,
        onClick,
        icon: Icon,
        showChevron = true,
    }: {
        label: string;
        onClick: () => void;
        icon: React.ElementType;
        showChevron?: boolean;
    }) => (
        <button type="button" onClick={onClick} style={optionRowStyle} aria-label={label}>
            <div style={{display: "flex", alignItems: "center", gap: token("space.150", "12px")}}>
                <Icon label="" color={token("color.icon")} />
                <AnankeText color="color.text.subtle">{label}</AnankeText>
            </div>
            {showChevron === true ? (
                <ChevronRightIcon label="" color={token("color.icon.subtle")} />
            ) : null}
        </button>
    );

    return (
        <div className="grid gap-ds-space-100" style={{fontFamily: "Inter"}}>
            {onExport !== undefined ? (
                <OptionRowButton label="Export" onClick={onExport} icon={DownloadIcon} />
            ) : null}
            {onArchivedData !== undefined ? (
                <OptionRowButton
                    label="Archived Data"
                    onClick={onArchivedData}
                    icon={(props) => <DeleteIcon {...props} label="" />}
                    showChevron={false}
                />
            ) : null}
        </div>
    );
}
